import axiosInstance from "../config/axios"; // adjust path to match your projecti
import { axiosInstanceV2 } from "../config/axios";
// ── format published_at date ──────────────────────────────────────────────────
// "2026-08-26" → "26 August 2026"
export const formatBlogDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

// ── split HTML body in half for body_image insertion ─────────────────────────
// splits at the nearest </p> boundary to the midpoint
// export const splitBodyAtMidpoint = (htmlString) => {
//   if (!htmlString) return { first: "", second: "" };

//   // extract all <p>...</p> blocks
//   const paragraphs = htmlString.match(/<p[\s\S]*?<\/p>/gi) || [];
//   if (paragraphs.length <= 1) {
//     return { first: htmlString, second: "" };
//   }

//   const mid = Math.ceil(paragraphs.length / 2);
//   const first = paragraphs.slice(0, mid).join("");
//   const second = paragraphs.slice(mid).join("");
//   return { first, second };
// };


export const splitBodyAtMidpoint = (htmlString) => {
  if (!htmlString) {
    return { first: "", second: "" };
  }

  // Create a temporary container to parse the HTML
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  // Get all top-level elements
  const blocks = Array.from(doc.body.children);

  if (blocks.length <= 1) {
    return {
      first: htmlString,
      second: "",
    };
  }

  // Find the midpoint
  const mid = Math.ceil(blocks.length / 2);

  // Convert the elements back to HTML
  const first = blocks
    .slice(0, mid)
    .map((element) => element.outerHTML)
    .join("");

  const second = blocks
    .slice(mid)
    .map((element) => element.outerHTML)
    .join("");

  return {
    first,
    second,
  };
};



// ── API calls ─────────────────────────────────────────────────────────────────
export const fetchBlogCategories = async () => {
  //const res = await axiosInstance.get("blog-categories");
  const res = await axiosInstanceV2.get("categories?_fields=id,name,slug")
  
  return res.data; // returns array of { id, name, slug }
};

export const fetchBlogs = async ({ categories = "", search = "" } = {}) => {
  const params = new URLSearchParams();

  if (categories) params.append("categories", categories);

  if (search) params.append("search", search);

  const query = params.toString();

  const res = await axiosInstanceV2.get(
    `posts${query ? `?${query}&_fields=id,slug,title,excerpt,date,author_name,featured_image,category_name` : ""}`
  );

  return res.data;
};

export const fetchSingleBlog = async (id) => {
  const res = await axiosInstanceV2.get(`posts/${id}?_fields=id,slug,title,content,date,author_name,featured_image,category_name,related_posts,seo_title,seo_description,yoast_head_json`);
 
  return res.data;
};



export const shortenExcerpt = (html, maxLength = 180) => {
  if (!html) return "";

  // Remove HTML tags
  const text = html.replace(/<[^>]*>/g, "");

  // Decode common HTML entities
  const decodedText = text
    .replace(/&amp;/g, "&")
    .replace(/&nbsp;/g, " ")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .trim();

  if (decodedText.length <= maxLength) {
    return decodedText;
  }

  // Avoid cutting in the middle of a word
  return `${decodedText.substring(0, maxLength).replace(/\s+\S*$/, "")}...`;
};